module.exports = __webpack_public_path__ + "static/logo-388307e6cfe527ce7fa8ec6389ce6dee.png";